import React from 'react';

function Instructions() {
    return (
        <div className="text-gray-800">
            <h2 className="mt-4"><span className="text-purple-800 font-medium">Note:</span> Startup events are available from Spring Boot 2.4 M3</h2>
            <h2 className="mt-4">Configure Spring Boot application to collect startup events:</h2>
            <p>
                <pre className="w-full bg-gray-800 text-white px-4 py-4 my-4 rounded whitespace-pre">
                    @SpringBootApplication<br/>
                    public class DemoApplication &#123;<br/>
<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;public static void main(String[] args) &#123;<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SpringApplication app = new SpringApplication(DemoApplication.class);<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;app.setApplicationStartup(new BufferingApplicationStartup(1000));<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;app.run(args);<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&#125;<br/>
                    &#125;<br/>
                </pre>
            </p>
            <h2 className="mt-4"><span className="text-purple-800 font-medium">Note:</span> you must enable CORS on Actuator "startup" endpoint in <code className="bg-gray-800 text-white px-1 py-1 rounded">application.properties</code> to analyze startup report through this website</h2>
            <p>
                <pre className="w-full bg-gray-800 text-white px-4 py-4 my-4 rounded">
                    management.endpoints.web.exposure.include=startup<br/>
                    management.endpoints.web.cors.allowed-origins=https://spring-boot-startup-analyzer.netlify.app<br/>
                    management.endpoints.web.cors.allowed-methods=GET,POST<br/>
                    </pre>

            </p>
        </div>
    );
}

export default Instructions;
